import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class MLVehicleInfoLookupService {
    static lookupVehicleInfoBasedOnVin(vin, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('vehicleInfoLookup'),
            'lookupBasedOnVIN',
            [vin],
            additionalHeaders
        );
    }

    static lookupMakes(lookupRequest, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('vehicleInfoLookup'),
            'lookupMakes',
            [lookupRequest],
            additionalHeaders
        );
    }

    static lookupModels(lookupRequest, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('vehicleInfoLookup'),
            'lookupModels',
            [lookupRequest],
            additionalHeaders
        );
    }

    static lookupVin(lookupVinRequest, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('vehicleInfoLookup'),
            'lookupVin',
            [lookupVinRequest],
            additionalHeaders
        );
    }

    static autofillBasedOnPartialDto(dto, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('vehicleInfoLookup'),
            'lookupBasedOnPartialDTO',
            [dto],
            additionalHeaders
        );
    }

    static verifyVin(verifyVinRequest, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('vehicleInfoLookup'),
            'verifyVin',
            [verifyVinRequest],
            additionalHeaders
        );
    }

    static lookUpCollisionCompSymbol(lookupRequest, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('vehicleInfoLookup'),
            'lookupCompColl',
            [lookupRequest],
            additionalHeaders
        );
    }

    static orderReportsForPrefillVehicles(jobNumber, additionalHeaders= {}){
        return JsonRPCService.send(
            getProxiedServiceUrl('vehicleInfoLookup'),
            'orderReportsForPrefillVehicles',
            [jobNumber],
            additionalHeaders
        );
    }
}
